import React, { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';

const About = () => {
  const { darkMode } = useContext(ThemeContext);
  
  return (
    <div className={`flex-1 flex flex-col ${darkMode ? 'dark' : ''} bg-gray-100 dark:bg-gray-900`}>
      <div className="px-4 sm:px-5 lg:px-7 flex-grow">
        <div className="max-w-[1440px] mx-auto py-10">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">About Us</h1>

          <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-md rounded-lg p-6 mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">Our Story</h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              As car enthusiasts ourselves, we found that our local shops and mechanics had been struggling with overly complicated, bogged-down invoicing software. We set out to create a streamlined, no-nonsense program that allows shops and independent mechanics to outline and invoice their work without the unnecessary clutter that gets in the way of providing a clean, professional invoice to their customers.
            </p>
            <p className="text-gray-700 dark:text-gray-300">
              When we first started asking our local shops how much they were paying for their current programs, we were floored. Price was a big factor — we wanted to make the lives of those working in the automotive community easier by easing the financial pain that comes with overpriced software.
            </p>
          </div>

          <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-md rounded-lg p-6 mb-8">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">Our Mission</h2>
            <p className="text-gray-700 dark:text-gray-300">
              Our mission at Stonewall Invoicing is to provide auto repair shops and independent mechanics with affordable, straightforward invoicing software that just works. No bloat, no unnecessary complexity — just the tools you need to create professional invoices, manage your customers, and get back to what you do best: working on cars.
            </p>
          </div>

          <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-md rounded-lg p-6">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">Our Values</h2>
            <ul className="list-disc pl-5 space-y-2 text-gray-700 dark:text-gray-300">
              <li><strong>Customer-Centric:</strong> We prioritize the needs of our customers in everything we do.</li>
              <li><strong>Innovation:</strong> We're constantly looking for new ways to improve our product and stay ahead of industry trends.</li>
              <li><strong>Reliability:</strong> We build software that our customers can depend on, with uptime and performance as top priorities.</li>
              <li><strong>Simplicity:</strong> We believe that powerful software doesn't have to be complicated to use.</li>
              <li><strong>Integrity:</strong> We are honest and transparent in all our business dealings.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;